import type { CredentialResponse } from '@react-oauth/google';
import { type OauthToken, createOauthToken } from 'models';
import { useMutation } from 'query';
import { getCurrentUserTimezone } from 'common/utils';
import { loginWithSocial } from '../../services';

type P = {
  code: CredentialResponse['credential'];
  organizationId?: string;
};

const defaultMutateOnError = () => {
  // Do nothing
  // This mutation is used within other mutation that handle error already
};

export const useLoginWithSocial = () =>
  useMutation<OauthToken, P>({
    defaultMutateOnError,
    async mutationFn({ code, organizationId }) {
      const oauthResponse = await loginWithSocial({
        body: {
          /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
          code,
          organization_id: organizationId,
          // TODO: this is also in header, why it needs to be in body? ask BE if we can remove it here
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          organization_slug: import.meta.env.VITE_APP_CONFIG,
          provider: 'google_v2',
          time_zone: getCurrentUserTimezone(),
        },
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createOauthToken(oauthResponse.data);
    },
  });
